import { render, staticRenderFns } from "./BannerCookies.vue?vue&type=template&id=1bc32cc8&scoped=true&"
import script from "./BannerCookies.vue?vue&type=script&lang=js&"
export * from "./BannerCookies.vue?vue&type=script&lang=js&"
import style0 from "./BannerCookies.vue?vue&type=style&index=0&id=1bc32cc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc32cc8",
  null
  
)

export default component.exports